const features = [
  {
    icon: 'ri-flashlight-line',
    title: '即点即播不缓冲',
    desc: '采用智能预加载和CDN加速技术，点击即播无需等待，告别卡顿和缓冲，给你最流畅的观影体验。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质全覆盖',
    desc: '支持1080P超清画质，热门资源更提供4K选项，在任意设备上都能享受影院级视觉盛宴。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新海量资源',
    desc: '日更新200+部影视内容，覆盖12大频道，热门剧集上线后最快2小时同步，永不错过精彩。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm text-foreground-500">为什么选择天狼影院</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feature, i) => (
            <div
              key={i}
              className="text-center p-6 bg-background-100 rounded-lg border border-background-200"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-4">
                <i className={`${feature.icon} text-primary-600 text-2xl`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-950 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}